export const columns = [
  {
    field: 'transportation.content',
    headerName: 'Görev Başlığı',
    width: 200,
    renderCell: (data) => {
      return <span>{data?.row?.transportation?.transportation?.content}</span>;
    },
  },
  {
    field: 'vehicle.id',
    headerName: 'Araç Plakası',
    width: 150,
    renderCell: (data) => {
      return (
        <span>{data?.row?.transportation?.transportation?.vehicle?.id}</span>
      );
    },
  },
  {
    field: 'driver.id',
    headerName: 'Şoför Adı',
    width: 150,
    renderCell: (data) => {
      return <span>{data?.row?.driver?.id}</span>;
    },
  },
  {
    field: 'time',
    headerName: 'Tarih',
    width: 150,
    notFilter: true,
    renderCell: (e) => (
      <div>{e.value ? new Date(e.value).toLocaleString('tr') : ''}</div>
    ),
  },
];
